var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h3',[_vm._v(_vm._s(_vm.$t("message.create-item-title")))]),_c('v-card',{attrs:{"flat":""}},[_c('v-col',{staticClass:"pr-2 pb-2",attrs:{"cols":"12"}},[_c('FormGroup',{on:{"on-submit":_vm.createItem}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }